import HomeImage from '../../components/LoginImage';
import LoginForm from '../../components/forms/LoginForm';
import { notification } from 'antd';
import React, { useEffect } from 'react';
import './styles.css';
import AppHeader from '../../components/AppHeader';
import { useSetPageTitle } from '../../utils/hooks';

const SESSION_EXPIRED = 'sessionExpired';

const removeErrorQueryParams = () =>
  window.history.replaceState(null, '', '/login');

const LoginPage = () => {
  useSetPageTitle('Login');
  const error = new URLSearchParams(window.location.search).get('error');

  const [notificationInstance, contextHolder] = notification.useNotification();
  const popUpNotification = (notificationType, config) => {
    notificationInstance[notificationType]({
      message: config.title,
      description: config.description,
    });
  };

  useEffect(() => {
    if (error) {
      removeErrorQueryParams();
      if (error === SESSION_EXPIRED) {
        popUpNotification('error', {
          title: 'Error',
          description: 'The session has expired, please login again',
        });
      } else {
        popUpNotification('error', {
          title: 'Error',
          description: 'Something went wrong, please try again later',
        });
      }
    }
  }, []);

  return (
    <>
      <AppHeader />
      <div className={'login-page'}>
        {contextHolder}
        <HomeImage />
        <div className={'login-container'}>
          <div className={'login-body'}>
            <h1>Login</h1>
            <LoginForm popUpNotification={popUpNotification} />
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
